<template>
  <div class="international-trade-chart">
    <div class="international-trade-chart__header">
      <SectionTitle v-if="title" :text="title" class="international-trade-chart__title" />
      <RedesignedSwitchComponent
        v-if="nameTable"
        :textTrue="textTrue"
        :textFalse="textFalse"
        @switchHandler="switchHandler"
        class="switch-back--big"
      />
    </div>
    <!-- Диаграмма -->
    <EChartsHorizontalBar
      v-if="switchChart && chartLabels.length"
      :valueFractionDigits="1"
      :barMaxWidth="20"
      :categoryLabelWidth="280"
      :xAxisMaxRatio="1.2"
      :labels="chartLabels"
      :dataset="chartDataset"
    />
    <!-- Таблица -->
    <InternationalTradeExportTable
      v-else-if="!switchChart"
      class="mt-0"
      dividerLabel="тыс $"
      :name="nameTable"
      :currentSummary="currentSummary"
      :exportGroups="exportGroups"
      :exportGroupsPrevious="exportGroupsPrevious"
      :topExportGroups="topExportGroups"
    />
  </div>
</template>

<script>
  import RedesignedSwitchComponent from '@/common/components/redesigned/RedesignedSwitchComponent.vue';
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import Constants from '@/common/constants';

  import EChartsHorizontalBar from '@/components/ChartComponents/apacheEcharts/EChartsHorizontalBar.vue';

  import InternationalTradeExportTable from './InternationalTradeExportTable.vue';

  export default {
    name: 'InternationalTradeChart',
    components: {
      RedesignedSwitchComponent,
      EChartsHorizontalBar,
      InternationalTradeExportTable,
      SectionTitle,
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      textTrue: {
        type: String,
        default: 'Диаграмма',
      },
      textFalse: {
        type: String,
        default: 'Таблица',
      },
      typeChart: {
        type: String,
        default: '',
      },
      nameTable: {
        type: String,
        default: '',
      },
      exportGroups: {
        type: String,
        default: '',
      },
      exportGroupsPrevious: {
        type: String,
        default: '',
      },
      topExportGroups: {
        type: String,
        default: '',
      },
      currentSummary: {
        type: Object,
        default: () => {},
      },
      switchChartProp: {
        type: Boolean,
        default: true,
      },
      legendName: {
        type: Object,
        default: () => {
          return {
            current: '',
            previous: '',
          };
        },
      },
    },
    data() {
      return {
        switchChart: this.switchChartProp,
      };
    },
    computed: {
      chartItems() {
        if (!this.currentSummary || !this.typeChart) return [];
        return this.currentSummary[this.typeChart] ?? [];
      },
      chartLabels() {
        return this.chartItems.map((item) => item.fullName || item.title || '');
      },
      chartDataset() {
        if (!this.chartItems.length) return [];

        return [
          {
            label: this.legendName?.current || '',
            data: this.chartItems.map((item) => Number((item.currentValue / Constants.MILLION).toFixed(1))),
            color: '#05B1E0',
          },
          {
            label: this.legendName?.previous || '',
            data: this.chartItems.map((item) => Number((item.previousValue / Constants.MILLION).toFixed(1))),
            color: '#00DEB6',
          },
        ];
      },
    },
    methods: {
      switchHandler() {
        this.switchChart = !this.switchChart;
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '@/assets/theme/default/title.scss';

  .international-trade-chart {
    margin-top: 60px;

    &__header {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
    }

    @media (max-width: $mobile) {
      &__header {
        flex-direction: column;
      }
    }
  }
</style>
